import { render, staticRenderFns } from "./LatestConversationBlock.vue?vue&type=template&id=4f493c44&scoped=true"
import script from "./LatestConversationBlock.vue?vue&type=script&lang=js"
export * from "./LatestConversationBlock.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/chat.css?vue&type=style&index=0&id=4f493c44&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f493c44",
  null
  
)

export default component.exports